/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useSnapshot } from 'valtio';

import Filter from './filter';

import { refsStore, gmapStore } from '../managers/globalState';
import { GMAP_CATEGORIES } from '../config/constants';
import { updateYear, updateCategory } from '../helpers/processGmap';

import '../../www/assets/css/gmap_dropdowns.css';

const GmapDropdowns = () => {
	// Get the year and category index global state.
	const { yearIndex, gmapcategoryIndex, showOnGlobeGmap } = useSnapshot(gmapStore.state);
  // console.log("gmap_dropdowns", yearIndex, gmapcategoryIndex,showOnGlobeGmap)
	// Get the content manager using the global state 'get' reference.
	const { get } = useSnapshot(refsStore.state);
	const { gmapYears } = get('content');

	let showSpacecraft = false;
	const router = get('route');

	if (router?._history?.location?.pathname) {
		const { pathname } = router._history.location;
		showSpacecraft = pathname.indexOf('spacecraft') >= 0;
	}

	if (showSpacecraft) {
		return null;
	}

	return (
		<div
			className={'gmap-dropdowns-container' + (showOnGlobeGmap ? ' gmap-dropdowns-offset' : '')}
		>
			<Filter type='dropdown' allItems={gmapYears} updateItem={updateYear} selectedIndex={yearIndex} />
			<Filter type='dropdown' allItems={GMAP_CATEGORIES} updateItem={updateCategory} selectedIndex={gmapcategoryIndex} minWidth='130px' />
		</div>
	);
};


export default GmapDropdowns;
